import { GET_BY_USER_ID_CONFIGURATION, UPDATE_USER_CONFIGURATION, GET_ERRORS } from "../actions/types";

const initialState = {
	userConfiguration : null,
	actionType:         '',
	error:              ''
};

export default function (state = initialState, action) {
	switch (action.type) {
		case GET_BY_USER_ID_CONFIGURATION:
			return {
				...state,
				actionType:        action.type,
				userConfiguration: action.payload
			};
		case UPDATE_USER_CONFIGURATION:
			return {
				...state,
				actionType: action.type
			};
		case GET_ERRORS:
			return {
				...state,
				actionType: action.type,
				error:      action.payload
			};
		default:
			return state;
	}
}
